import { render } from "./PrivateLayout.vue?vue&type=template&id=1deca1a4&scoped=true"
import script from "./PrivateLayout.vue?vue&type=script&lang=js"
export * from "./PrivateLayout.vue?vue&type=script&lang=js"

import "./PrivateLayout.vue?vue&type=style&index=0&id=1deca1a4&scoped=true&lang=scss"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1deca1a4"]])

export default __exports__